// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// import wastelogo from '../../images/logo/waste-pilot.svg';
// import { Typography } from '@mui/material';
// import MobileMenu from '../MobileMenu/MobileMenu';
// import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
// import { useSelector } from 'react-redux'; // Import useSelector
// import { NavLink } from 'react-router-dom';

// const Header2 = (props) => {
//   console.log('props', props);

//   const [mobailActive, setMobailState] = useState(false);

//   const ClickHandler = () => {
//     window.scrollTo(10, 0);
//   };

//   const [isSticky, setSticky] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 80) {
//         setSticky(true);
//       } else {
//         setSticky(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);

//     // Clean up
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   const SubmitHandler = (e) => {
//     e.preventDefault();
//   };

//   return (
//     <div
//       id="xb-header-area"
//       className="header-area header-style-one header-transparent"
//     >
//       <div
//         className={`xb-header stricky  ${
//           isSticky ? 'stricked-menu stricky-fixed' : ''
//         }`}
//       >
//         <div className="container-fluid">
//           <div className="header__wrap pd-70 ul_li_between">
//             <div className="header-logo">
//               <Link onClick={ClickHandler} to="" className="logo01">
//                 <img width={100} src={wastelogo} alt="" />
//               </Link>
//               <Link onClick={ClickHandler} to="/" className="logo02">
//                 <img width={100} src={wastelogo} alt="" />
//               </Link>
//             </div>

//             <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
//               <nav className="main-menu collapse navbar-collapse">
//                 <ul>
//                   {/* <li>
//                     <Link
//                       onClick={ClickHandler}
//                       className="iconbox_block_2"
//                       to="/login"
//                     >
//                       <span>Log In</span>
//                     </Link>
//                   </li> */}
//                   <li>
//                     <NavLink
//                       onClick={ClickHandler}
//                       className="iconbox_block_2"
//                       to="/about"
//                     >
//                       <span>About Us</span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink onClick={ClickHandler} to="/contact">
//                       <span>Contact</span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink onClick={ClickHandler} to="/faq">
//                       <span>Faq</span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </nav>
//               {/*
//               <div className="xb-header-wrap">
//                 <div
//                   className="basket-wrapper"
//                   style={{
//                     borderLeft: '2px solid white', // Adjust thickness and color
//                     paddingLeft: '15px', // Add spacing for better visibility
//                   }}
//                 >
//                   <Link to="/confirm" className="basket-icon">
//                     <ShoppingBasketIcon
//                       fontSize="large"
//                       sx={{ color: '#378D3B' }}
//                     />
//                     {totalQuantity > 0 && (
//                       <span
//                         className="cart-count"
//                         style={{
//                           backgroundColor: 'white',
//                           color: 'black',
//                           borderRadius: '50%',
//                           width: '24px',
//                           height: '24px',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           fontSize: '14px',
//                           fontWeight: 'bold',
//                           position: 'absolute',
//                           top: '-5px',
//                           right: '-3px',
//                         }}
//                       >
//                         {totalQuantity}
//                       </span>
//                     )}
//                   </Link>
//                 </div>

//                 <div
//                   className={`xb-header-menu ${mobailActive ? 'active' : ''}`}
//                 >
//                   <MobileMenu />
//                 </div>
//               </div> */}
//             </div>
//             <div className="header-bar-mobile side-menu d-xl-none">
//               <button
//                 className="xb-nav-mobile"
//                 onClick={() => setMobailState(!mobailActive)}
//               >
//                 <i className="far fa-bars"></i>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header2;
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import wastelogo from '../../images/logo/waste-pilot.svg';
import { Typography } from '@mui/material';
import './Header2.css'; // Optional: for custom CSS
import { useDispatch, useSelector } from 'react-redux';

const Header2 = ({
  companyName,

  BookDumpster,
  OrderBilling,
  Faq,
  About,
  Contact,
}) => {
  const { dumpsters } = useSelector((state) => state?.dumpsters || {});
  const customerPanelUrl =
    dumpsters?.company?.customer_panel_url || 'Unknown URL';

  return (
    <>
      <header className="custom-header">
        <div className="container-fluid header-content">
          {/* Logo */}
          {/* <div className="header-left">
            <img
            
              src={wastelogo}
              alt="Waste Pilot Logo"
              className="header-logo"
            />
          </div> */}
          <div className="header-left">
            <a href={customerPanelUrl}>
              <img
                src={wastelogo}
                alt="Waste Pilot Logo"
                className="header-logo"
              />
            </a>
          </div>

          {/* Center Title */}
          <div className="header-center">
            <Typography variant="h5" className="header-title">
              {/* Main title fallback */}
              {(companyName && `${companyName} Dumpster Sizes`) ||
                BookDumpster ||
                null}

              {/* Optional additional info with spacing */}
              {OrderBilling && `  ${OrderBilling}`}
              {Faq && ` ${Faq}`}
              {About && `  ${About}`}
              {Contact && `  ${Contact}`}
            </Typography>
          </div>

          {/* Nav Links */}
          <nav className="header-right">
            {/* <NavLink to="/faq" className="header-link">
              FAQ
            </NavLink>
            <NavLink to="/about" className="header-link">
              About Us
            </NavLink>
            <NavLink to="/contact" className="header-link">
              Contact Us
            </NavLink> */}
          </nav>
        </div>
      </header>
      <div
        style={{ maxWidth: '1400px', margin: '0 auto', padding: '10px 20px' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '16px',
            fontSize: '17px',
            fontWeight: '400',
          }}
        >
          <NavLink
            to="/faq"
            className={({ isActive }) =>
              isActive ? 'header-link active-link' : 'header-link'
            }
          >
            FAQ
          </NavLink>

          <span style={{ borderLeft: '1px solid #ccc', height: '18px' }}></span>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? 'header-link active-link' : 'header-link'
            }
          >
            About Us
          </NavLink>

          <span style={{ borderLeft: '1px solid #ccc', height: '18px' }}></span>

          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive ? 'header-link active-link' : 'header-link'
            }
          >
            Contact Us
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Header2;
